var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter } from 'eventemitter3';
var LocalEvent;
(function (LocalEvent) {
    LocalEvent["EDITOR_CREATED"] = "editor-created";
    LocalEvent["TEXT_CHANGED"] = "text-change";
    LocalEvent["SELECTION_CHANGED"] = "selection-change";
    LocalEvent["ON_CHANGE"] = "state-change";
    LocalEvent["ON_BLUR"] = "blur";
    LocalEvent["ON_FOCUS"] = "focus";
    LocalEvent["EDITOR_WILL_UNMOUNT"] = "editor-will-unmount";
    LocalEvent["SWITCH_LAYER"] = "switch-layer";
    LocalEvent["LOCALE_CHANGE"] = "locale-change";
    LocalEvent["CONFIG_PLUGIN_CHANGE"] = "config-plugin-change";
})(LocalEvent || (LocalEvent = {}));
var EventChannel = /** @class */ (function (_super) {
    __extends(EventChannel, _super);
    function EventChannel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EventChannel.LocalEvent = LocalEvent;
    return EventChannel;
}(EventEmitter));
export { EventChannel, LocalEvent };
//# sourceMappingURL=event.js.map